import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const ScenarioFlowStepMeta: ComponentMeta = {
  componentName: "ScenarioFlowStep",
  package: "custom",
  title: "流程节点",
  description: "场景中的流程项，仅可在场景容器内拖拽排序",
  category: ComponentCategory.DATA_DISPLAY,
  icon: "NodeIndexOutlined",
  canHaveChildren: false,
  editorDnd: {
    draggable: true,
    allowedParentNames: ["ScenarioFlowScene"],
  },
  props: [
    {
      name: "flowId",
      label: "流程ID",
      type: PropType.STRING,
      group: "数据",
    },
    {
      name: "code",
      label: "流程编码",
      type: PropType.STRING,
      defaultValue: "HC4000",
      group: "数据",
    },
    {
      name: "title",
      label: "流程标题",
      type: PropType.STRING,
      group: "数据",
    },
    {
      name: "status",
      label: "状态",
      type: PropType.ENUM,
      defaultValue: "pending",
      options: [
        { label: "待执行", value: "pending" },
        { label: "成功", value: "done" },
        { label: "失败", value: "error" },
      ],
      group: "状态",
    },
    {
      name: "disabled",
      label: "禁用拖拽",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "功能",
    },
  ],
  defaultProps: {
    code: "HC4000",
    status: "pending",
    disabled: false,
  },
  npm: {
    package: "@mijalowcode/materials",
    exportName: "ScenarioFlowStep",
  },
  snippet: {
    componentName: "ScenarioFlowStep",
    package: "custom",
    props: {
      flowId: "HC4000",
      code: "HC4000",
      status: "pending",
    },
  },
};
